<template>
	<div class="user-notification" style="width: 100%; height: 85vh; overflow-y: auto">
		<div class="header">
			<div class="header_title-container title">
				<h1>{{ $t("notifications") }}</h1>
			</div>
		</div>

		<div class="notification-form-container">
			<div class="notification-form">
				<div class="notification-title">
					<div class="title-label">{{ $t("notification-title") }}</div>
					<div class="title-input">
						<input
							type="text"
							maxlength="50"
							show-word-limit
							v-model="message.title"
							:placeholder="$t('title')"
							style="margin-right: 15px"
						/>
						{{ message.title.length }}/50 {{ $t("characters") }}
					</div>
				</div>
				<div class="notification-type">
					<div class="type-title">{{ $t("tipo") }}:</div>
					<div class="type-options">
						<div
							class="option"
							v-for="typ in types"
							:key="typ.name"
							@click="changeType(typ.name)"
							:class="message.type === typ.name ? 'active' : ''"
							:style="{ 'background-color': message.type === typ.name ? typ.color : '#fff' }"
						>
							<div class="circle">
								<div
									class="round"
									:style="{ 'background-color': typ.color }"
									v-if="message.type !== typ.name"
								></div>
								<div v-else>
									<md-icon style="color: #fff !important; font-weight: 900">{{ typ.icon }}</md-icon>
								</div>
							</div>
							<div class="text">{{ $t(typ.name) }}</div>
						</div>
					</div>
				</div>
				<div class="notification-text">
					<div class="text-title">{{ $t("notification-text") }}</div>
					<div class="textarea">
						<textarea
							maxlength="250"
							v-model="message.content"
							:placeholder="$t('text')"
							style="margin-right: 15px"
							rows="3"
						></textarea>
						{{ message.content ? message.content.length : 0 }}/250 {{ $t("characters") }}
					</div>
				</div>
			</div>
			<div class="notification-send">
				<div class="send-title">
					<div class="send-label">{{ $t("receiver-options") }}</div>
				</div>

				<div class="buttons" style="padding-bottom: 50px">
					<div class="send-all">
						<div class="all-btn" @click="sendAll()">
							<div class="icon">
								<md-icon>send</md-icon>
							</div>
							<div class="text">{{ $t("all-users") }}</div>
						</div>
					</div>
					<div class="separator">
						<div class="line"></div>
					</div>
					<div class="send-doc">
						<div class="send-input">
							<div class="send-input-label">{{ $t("send-to") }}</div>
							<div class="send-input-input">
								<el-select
									v-model="selectedDoc"
									multiple
									:placeholder="$t('documents-search')"
									style="width: 100%"
									filterable
								>
									<el-option
										v-for="document in documents"
										:key="document.Id"
										:label="document.Title"
										:value="document.UniqueID"
									></el-option>
								</el-select>
							</div>
						</div>
						<div class="send-doc-btn">
							<div class="all-btn" @click="sendFilter()">
								<div class="icon">
									<md-icon>send</md-icon>
								</div>
								<div class="text">{{ $t("user-with-flowchart-id") }}</div>
							</div>
						</div>
					</div>
					<div class="separator">
						<div class="line"></div>
					</div>
					<div class="send-doc">
						<div class="send-input">
							<div class="send-input-label">{{ $t("send-to") }}</div>
							<div class="send-input-input">
								<el-select
									v-model="selectedRegion"
									multiple
									:placeholder="$t('geographic-area-search')"
									style="width: 100%"
									filterable
								>
									<el-option v-for="reg in regioni" :key="reg" :label="reg" :value="reg"></el-option>
								</el-select>
							</div>
						</div>
						<div class="send-doc-btn">
							<div class="all-btn" @click="sendReg()">
								<div class="icon">
									<md-icon>send</md-icon>
								</div>
								<div class="text">{{ $t("user-with-geographic-area") }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import axios from "axios"

export default {
	components: {},
	name: "usernotifications",
	data() {
		return {
			loading: false,
			height2: window.innerHeight / 2 - 270,
			height: window.innerHeight - 270,
			documents: [],
			selectedDoc: [],
			selectedRegion: [],
			message: {
				title: "",
				type: {},
				body: "",
				doc: undefined
			},
			regioni: [
				"Abruzzo",
				"Basilicata",
				"Calabria",
				"Campania",
				"Emilia-Romagna",
				"Friuli-Venezia Giulia",
				"Lazio",
				"Liguria",
				"Lombardia",
				"Marche",
				"Molise",
				"Piemonte",
				"Puglia",
				"Sardegna",
				"Sicilia",
				"Toscana",
				"Trentino-Alto Adige",
				"Umbria",
				"Valle d'Aosta",
				"Veneto"
			],
			types: [
				{ name: "success", title: "success", color: "#9ccc65", icon: "done" },
				{ name: "warning", title: "warning", color: "#ffca28", icon: "warning" },
				{ name: "danger", title: "danger", color: "#ff8a65", icon: "clear" },
				{ name: "info", title: "info", color: "#bdbdbd", icon: "help" }
			]
		}
	},
	computed: {
		...mapGetters({
			users: "users/users"
		})
	},

	methods: {
		getDocuments() {
			axios
				.post(
					`${process.env.VUE_APP_API_URL}/api/flowchart/all`,
					{},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					this.documents = res.data.items
				})
				.catch(err => console.error(err))
		},
		sendAll() {
			axios
				.post(
					`${process.env.VUE_APP_API_URL}/api/notification/sendAll`,
					{ title: this.message.title, type: this.message.type, body: this.message.content },
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("notification-sent"), "", 4000)
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
					console.error(err)
				})
		},
		sendFilter() {
			axios
				.post(
					`${process.env.VUE_APP_API_URL}/api/notification/sendFilter`,
					{
						title: this.message.title,
						type: this.message.type,
						body: this.message.content,
						docs: this.selectedDoc
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("notification-sent"), "", 4000)
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
					console.error(err)
				})
		},
		sendReg() {
			axios
				.post(
					`${process.env.VUE_APP_API_URL}/api/notification/sendFilter`,
					{
						title: this.message.title,
						type: this.message.type,
						body: this.message.content,
						reg: this.selectedRegion
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("notification-sent"), "", 4000)
				})
				.catch(err => {
					this.$processError(this.$t("save-error"), err.response.data.Message)
					console.error(err)
				})
		},
		changeType(t) {
			this.message.type = t
			this.$forceUpdate()
		}
	},
	watch: {
		users: function () {}
	},

	created() {
		this.getDocuments()
	}
}
</script>
<style scoped lang="scss">
.user-notification {
	font-family: "Montserrat", sans-serif;
	width: 100%;
	height: calc(100vh - 100px);
	display: flex;
	flex-direction: column;

	.notification-form-container {
		height: 100%;
		width: 100%;
		display: flex;

		.notification-form {
			width: 70%;
			display: flex;
			flex-direction: column;

			.notification-title {
				height: 15%;
				display: flex;

				.title-label {
					width: 50%;
					display: flex;
					justify-content: flex-end;
					height: 100%;
					align-items: center;
					font-size: 1.5rem;
				}

				.title-input {
					width: 50%;
					display: flex;
					justify-content: flex-start;
					height: 100%;
					padding-left: 20px;
					align-items: center;

					input {
						border: 1pt solid #ccc !important;
						border-radius: 7px;
						padding: 15px 15px;
						color: #232323;
						background-color: #fff;
						font-size: 1.1rem;
					}
				}
			}

			.notification-type {
				height: 15%;
				display: flex;
				flex-direction: column;

				.type-title {
					display: flex;
					justify-content: center;
					font-size: 1.5rem;
					width: 100%;
					align-items: center;
					height: 25%;
				}

				.type-options {
					flex: 1;
					display: flex;
					width: 100%;
					align-items: center;
					justify-content: space-evenly;

					.option {
						cursor: pointer;
						border: 1pt solid #ccc;
						border-radius: 10px;
						padding: 15px 15px;
						display: flex;
						width: 220px;
						transition: all 0.25s ease-in-out;

						&.active {
							.text {
								font-weight: 900;
								color: #fff;
								letter-spacing: 1px;
							}

							.round {
								background-color: #232323;
							}
						}

						.circle {
							width: 30%;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;

							.round {
								width: 20px;
								height: 20px;
								border-radius: 50%;
							}
						}

						.text {
							flex: 1;
							justify-content: center;
							height: 100%;
							padding-left: 5px;
							font-size: 1.1rem;
							align-items: center;
						}
					}
				}
			}

			.notification-text {
				flex: 1;
				display: flex;
				flex-direction: column;

				.text-title {
					height: 10%;
					display: flex;
					justify-content: center;
					font-size: 1.5rem;
					width: 100%;
					align-items: center;
				}

				.textarea {
					flex: 1;
					padding-top: 20px;
					padding-bottom: 20px;
					display: flex;
					justify-content: center;
					width: 100%;

					textarea {
						border: 1pt solid #ccc !important;
						font-family: "Montserrat", sans-serif;
						width: 60%;
						padding: 20px;
						border-radius: 10px;
						height: 50%;
						resize: none;
					}
				}
			}
		}

		.notification-send {
			width: 30%;
			display: flex;
			flex-direction: column;

			.send-title {
				height: 10%;
				display: flex;

				.send-label {
					width: 50%;
					display: flex;
					justify-content: flex-end;
					height: 100%;
					align-items: center;
					font-size: 1.5rem;
				}
			}

			.buttons {
				flex: 1;
				display: flex;
				flex-direction: column;

				.send-all {
					height: 25%;
					display: flex;
					justify-content: center;
					align-items: center;

					.all-btn {
						cursor: pointer;
						border-radius: 10px;
						display: flex;
						width: 200px;
						border: 1pt solid #aed581;
						background-color: #fff;
						padding: 20px 15px;
						transition: all 0.3s ease-in-out;

						.icon {
							width: 30%;
							height: 100%;
							display: flex;
							align-items: center;

							i {
								color: #aed581 !important;
								font-size: 35px !important;
							}
						}

						.text {
							width: 70%;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 1.2rem;
							font-weight: 900;
						}

						&:hover {
							background-color: #aed581;

							.icon i {
								color: #fff !important;
							}

							.text {
								color: #fff;
								font-size: 1.5rem;
							}
						}
					}
				}

				.separator {
					margin: 10px 0;
					padding: 0 30px;
					width: 100%;

					.line {
						height: 1px;
						width: 100%;
						background-color: rgba(204, 202, 203, 0.75);
					}
				}

				.send-doc {
					margin-top: 10px;

					.send-input {
						display: flex;
						flex-direction: column;

						.send-input-label {
							width: 100%;
							display: flex;
							justify-content: center;
							font-size: 1.2rem;
						}

						.send-input-input {
							margin-top: 15px;
							width: 100%;
							display: flex;
							justify-content: center;

							.el-select {
								width: 75% !important;
							}
						}
					}

					.send-doc-btn {
						display: flex;
						justify-content: center;
						margin-top: 10px;

						.all-btn {
							width: 250px;
						}
					}
				}
			}
		}
	}
}

.all-btn {
	cursor: pointer;
	border-radius: 10px;
	display: flex;
	width: 200px;
	border: 1pt solid #aed581;
	background-color: #fff;
	padding: 20px 15px;
	transition: all 0.3s ease-in-out;

	.icon {
		width: 30%;
		height: 100%;
		display: flex;
		align-items: center;

		i {
			color: #aed581 !important;
			font-size: 35px !important;
		}
	}

	.text {
		width: 70%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.2rem;
		font-weight: 900;
	}

	&:hover {
		background-color: #aed581;

		.icon i {
			color: #fff !important;
		}

		.text {
			color: #fff;
		}
	}
}
</style>
